export default __webpack_public_path__ + "static/media/ies_PagoVoces_ENG.54b62380.png";